/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DeviceService {
  /**
   * 导入节点 - 节点模板
   * @returns any 成功
   * @throws ApiError
   */
  static getDmNodeTemplate() {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/dm/node/template'
    });
  }
  /**
   * 导入节点 - 上传节点数据
   * @param formData
   * @returns any 成功
   * @throws ApiError
   */
  static postDmImportNodes(formData) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/import/nodes',
      formData: formData,
      mediaType: 'multipart/form-data'
    });
  }
  /**
   * 导入节点 - 查询导入节点列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmQueryTempNodes(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/query/temp/nodes',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 导入节点 - 更新节点信息
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmUpdateNode(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/update/node',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 导入节点 - 确定导入
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmAddBatchNodes(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/add/batch/nodes',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 导入节点 - 取消导入
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmCancelNodes(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/cancel/nodes',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 导入节点 - 删除/批量删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmDeleteNodes(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/delete/nodes',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 导入节点 - 确定 - 查询导入状态个数
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmAddBatchNodesCounts(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/add/batch/nodes/counts',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 新增/编辑节点
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmUpsert(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/upsert',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 删除/批量删除
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmDelete(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/delete',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 设备列表
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmList(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/list',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 查询单个节点信息
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmQueryMo(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/query/mo',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 设备码生成
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmCode(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/code',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 节点树
   * @returns any 成功
   * @throws ApiError
   */
  static postDmQuery() {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/query'
    });
  }
  /**
   * 日志
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmHistory(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/history',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 导出配置
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmExport(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/export',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  /**
   * 启用/禁用
   * @param requestBody
   * @returns any 成功
   * @throws ApiError
   */
  static postDmStateUpdate(requestBody) {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/dm/state/update',
      body: requestBody,
      mediaType: 'application/json'
    });
  }
}